// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"163":"895e7ce2","213":"9d521569","238":"9f64dbe6","239":"d9d04dfb","291":"b439dabd","295":"dc85d1f0","446":"5afcc54e","693":"da5c77cb","831":"e9310745","853":"ee4cf855"}[chunkId] + ".chunk.js";
};